angular.module('aprima-provider-api').factory('DrugRepository',
    ['_', 'AprimaRestangular', 'AprimaAnalytics', 'Guid',
        function (_, AprimaRestangular, AprimaAnalytics, Guid) {
            'use strict';

            return {
                getDrugFormularyInfo: getDrugFormularyInfo,
                getDrugRepresentativeFormularies: getDrugRepresentativeFormularies,
                getDrugFormularyDetail: getDrugFormularyDetail,
                nddDrugScreening: nddDrugScreening,
            };

            // This endpoint should not be called starting in PRM2018.
            function getDrugFormularyInfo(medId, patientId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'get drug formulary info');
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular.all('drugs/' + medId + '/formularyalternatives/' + patientId)
                                  .getList()
                                  .finally(timing.stop);
            }
            
            function getDrugRepresentativeFormularies(medId, eRxEligibilityId, patientId, relVisitMedicationId, pharmacyId, days, dispenseAsWritten, totalQuantity, unitOfMeasureId, previousPMBCParameters, previousRFSParameters, providerId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'get drug representative formularies');
                var restangular = AprimaRestangular.get(restangularOptions);
                var url = 'drugs/' + medId +
                          '/representativeformularies/' + (eRxEligibilityId || Guid.empty()) +
                          '?days=' + (days || '') +
                          '&dispenseAsWritten=' + (dispenseAsWritten || '') +
                          '&proposedRelVisitMedicationId=' + (relVisitMedicationId || '') +
                          '&patientId=' + (patientId || '') +
                          '&pharmacyId=' + (pharmacyId || Guid.empty()) +
                          '&totalQuantity=' + (totalQuantity || '') +
                          '&unitOfMeasureId=' + (unitOfMeasureId || '') +
                          '&previousPMBCParameters=' + (previousPMBCParameters ? encodeURIComponent(previousPMBCParameters) : '') +
                          '&previousRFSParameters=' + (previousRFSParameters ? encodeURIComponent(previousRFSParameters) : '') +
                          '&providerId=' + (providerId || Guid.empty()) +
                          (medId ? '' : '&ignoreCache=' + (new Date()).getTime());
                return restangular.one(url)
                                  .get()
                                  .finally(timing.stop);
            }
            
            function getDrugFormularyDetail(medId, patientId, restangularOptions){
                restangularOptions = restangularOptions || {ignoreCache: false};
                
                var timing = AprimaAnalytics.startTiming();
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular.all('drugs/' + medId + '/formularydetail/' + patientId).getList().finally(timing.stop);
            }

            function nddDrugScreening(patientId, drug, otherDrugs, previousMedicationSigId) {
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'nddDrugScreening');
                var restangular = AprimaRestangular.get();
                return restangular.one('patients/' + patientId + '/nddscreening')
                                  .customPOST({
                                      Drug: drug,
                                      OtherDrugs: otherDrugs,
                                      PreviousMedicationSigUid: previousMedicationSigId
                                  })
                                  .finally(timing.stop);

            }
        }]);